<template>
  <div class="slider" :style="imageCarier">
    <div class="slider__note">
      {{ title }}
    </div>
    <!-- <img :src="image" class="home__image"/> -->
  </div>
</template>

<script>
import export1 from "@/assets/export.jpg";
import export2 from "@/assets/export2.jpg";
import export3 from "@/assets/export3.jpg";
import brain from "@/assets/brain.jpg";
import training from "@/assets/training.jpg";
export default {
  name: "Slider",
  props: {
    title: {
      type: String,
      required: false,
      default: "",
    },
  },
  data() {
    return {
      image: "",
      imageList: [export1, export2, export3, brain, training],
    };
  },
  computed: {
    imageCarier() {
      return {
        "background-image": `url('${this.image}')`,
      };
    },
  },
  mounted() {
    this.autoPickImage();
  },
  methods: {
    autoPickImage() {
      const pickImage = Math.floor(Math.random() * this.imageList.length + 0);
      this.image = this.imageList[pickImage];
    },
  },
};
</script>

<style scoped>
.slider__note {
  background-color: #404c60b3;
  width: 70%;
  height: auto;
  font-size: 3rem;
  color: #ffffff;
  padding: 10px;
}

.slider {
  width: 100%;
  height: 94vh;
  overflow: hidden;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  background-attachment: fixed;
  background-color: white;
  display: flex;
  align-items: center;
  justify-content: center;
}
@media only screen and (max-width: 900px) {
  .slider {
    margin-top: 50px;
  }
}

@media only screen and (max-width: 420px) {
  .slider__note {
    font-size: 2.5rem;
    width: auto;
  }
}
</style>
